import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../utilities/services/http.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { ChatComponent } from '../chat/chat.component';

@Component({
  selector: 'app-new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.scss'],
})
export class NewMessageComponent implements OnInit, AfterViewInit {
  userList: any[] = [];
  filteredUserList: any[] = [];
  usersForm!: FormGroup;
  isLoading = false;
  selectedUser;

  @Input() forwardMsg: any;

  @Output() closeUser = new EventEmitter();
  @Output() gotoConversations = new EventEmitter();

  @ViewChild('dynamicallChat', { read: ViewContainerRef })
  private viewRef!: ViewContainerRef;

  constructor(
    private router: Router,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private httpService: HttpService,
    public translate: TranslateService
  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    this.getUsers()
  };

  getUsers() {
    this.httpService.getUsers("", 1000).subscribe((res) => {
      this.userList = res.data;
      this.filteredUserList = res.data;
    });
  }

  ngOnInit(): void {
    this.usersForm = this.fb.group({
      userInput: null,
    });

    // this.usersForm.get('userInput')?.valueChanges.pipe(
    //   debounceTime(300),
    //   tap(() => (this.isLoading = true)),
    //   switchMap((value) =>
    //     this.httpService.getUsers(value, 10)
    //       .pipe(finalize(() => (this.isLoading = false)))
    //   )
    // ).subscribe((res) => {
    //   this.userList = res.data;
    //   this.filteredUserList = res.data;
    // });
  }
  ngAfterViewInit(): void {
    this.usersForm.get('userInput')?.valueChanges.subscribe((res) => {
      console.log(res)
      this.filteredUserList = this.filterUserList(res);
    });
  }

  close() {
    // this.closeUser.emit(true);
    this.gotoConversations.emit(true);
  }

  displayFn(data: any) {
    if (data) { return data.user.name; }
  }

  onSelFunc(user: any) {
    if (!this.checkYou(user.user.email)) {
      this.addChatComponent(user.user.email, user.user.name);
      this.selectedUser = user.user.name;
    }
  }

  checkYou(email: string) {
    return localStorage.getItem('userEmail') === email;
  }

  addChatComponent(email: string, name: string) {
    if (this.viewRef) {
      this.viewRef.clear();
      // this.openChatList.push(email);
      const componentRef = this.viewRef.createComponent(ChatComponent, {
        index: 0,
      });
      componentRef.instance.fromNewMessage = true;
      componentRef.instance.forwardMsg = this.forwardMsg;
      componentRef.instance.toChatUserId = email;
      componentRef.instance.toChatUserName = name;
      componentRef.instance.gotoConversations.subscribe(() => {
        componentRef.destroy();
      });
    }
  }

  clearSearch() {
    // this.searchValue = "";
    this.usersForm.patchValue({ userInput: "" })
  }

  filterUserList(val) {
    let newFilteredList: any[] = [];
    let searchValue = val.toLowerCase()
    this.userList.map(user => {
      try {
        let userProfile = user.user;
        let userRole = user.Role;
        let userName = userProfile.Username;
        let userFullName = userProfile.LastName ? userProfile.LastName + ", " + userProfile.FirstName : "";
        let IVRID = userProfile.IVRID ? userProfile.IVRID : "";
        let agencyCode = userProfile.agencycode ? userProfile.agencycode : "";
        let branch = userProfile.Branch ? userProfile.Branch : "";

        if (userRole.toLowerCase().indexOf(searchValue) > -1 || userName.toLowerCase().indexOf(searchValue) > -1 
        || userFullName.toLowerCase().indexOf(searchValue) > -1 || IVRID.toLowerCase().indexOf(searchValue) > -1 
        || agencyCode.toLowerCase().indexOf(searchValue) > -1 || branch.toLowerCase().indexOf(searchValue) > -1) {
          newFilteredList.push(user)
        }
      } catch (error) {
        console.log(error)
       }
    })

    this.filteredUserList = newFilteredList;
    return newFilteredList
  }
}
